import React, { FC } from 'react';
import { Dialog } from '@mui/material';
import { connect } from 'react-redux';
import { IProps, IStateProps, IDispatchProps } from './interfaces';
import { IAppState } from '../../../state/reducers';
import { clearExchangeInfo } from '../../../state/exchange/exchangeInfo';
import ExchangeInfo from './ExchangeInfo/component';

const ExchangeInfoDialog: FC<IProps> = (props: IProps) => {
  const { isOpen, onClose } = props;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
    >
      <ExchangeInfo />
    </Dialog>
  );
};

const mapStateToProps = (state: IAppState): IStateProps => ({
  isOpen: state.exchange.exchangeInfo.isOpen,
});

const mapDispatchToProps: IDispatchProps = {
  onClose: clearExchangeInfo,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExchangeInfoDialog);
